import { useFlyOutProductsBasedOnSelectedCloud } from '../../utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import {
  type CloudAccountChangeParams,
  useCurrentCloudProvider,
} from '@labrav/common'
import { FlyoutFunction } from '../../../modules/productsListing/types'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { getFlyoutProductsListBasedOnFunction } from '../../../modules/productListingFilter/action'
import { isEmpty } from 'lodash'
import { SelectV4 } from '@labrav/react-components'
import { DataType } from '@labrav/react-components/lib/@types/types/forms'
import { SelectChangeEvent } from '@mui/material'

export interface CustomProductSelectorDropdownProps {
  functionType: FlyoutFunction
  openNewPrivateOfferModal?: boolean
  onProductChange: (selectedProduct: string) => void
  handleCloudAccountChange?: (params: CloudAccountChangeParams) => void
}

export const CustomProductSelectorDropdown: React.FC<
  CustomProductSelectorDropdownProps
> = ({
  functionType,
  openNewPrivateOfferModal,
  onProductChange,
  handleCloudAccountChange,
}: CustomProductSelectorDropdownProps) => {
  const { selectedProduct: productId, products } =
    useFlyOutProductsBasedOnSelectedCloud()
  const cloudMarketplace = useCurrentCloudProvider()
  const [selectedProduct, setSelectedProduct] = useState<string>('')

  useEffect(() => {
    setSelectedProduct(productId as string)
    onProductChange(productId as string)
  }, [
    productId,
    openNewPrivateOfferModal,
    handleCloudAccountChange,
    functionType,
  ])

  const handleProductChange = useCallback(
    async (event: SelectChangeEvent) => {
      const product = event.target.value as string
      const actualProductId = product === 'allProducts' ? '' : product
      await setSelectedProduct(actualProductId)
      await onProductChange(actualProductId)
    },
    [functionType, cloudMarketplace, onProductChange]
  )

  const productsForFilters = getFlyoutProductsListBasedOnFunction(
    products,
    functionType,
    cloudMarketplace
  )

  const defaultSelectedProduct = useMemo(() => {
    return isEmpty(selectedProduct) ? 'allProducts' : selectedProduct
  }, [selectedProduct])

  return (
    <SelectV4
      field={{
        title: 'Select a product',
        placeHolder: 'Select a product',
        id: 'product-selector-dropdown',
        isRequired: false,
        humanReadableKey: 'selectProduct',
        isReadOnly: products.length === 0,
        isCustom: false,
        defaultValue: defaultSelectedProduct,
        value: defaultSelectedProduct,
        dataType: 'enum' as DataType,
        options: productsForFilters,
      }}
      onChange={handleProductChange}
      isError={false}
    />
  )
}
